export { default } from './BenefitsTable';
export type { BenefitsProps } from './BenefitsTable';
